const componentStyles = (theme) => ({
  appBarRoot: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  pageTitle: {
    margin: "0",
    color: theme.palette.gray[800],
    fontSize: "1rem",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  containerRoot: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "39px",
      paddingRight: "39px",
    },
  },
});

export default componentStyles;